import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../../config";
import User from "../../../../services/user";
import Session from "../../utils/session";
import Page from "../../../../services/page-data-feed";
import MobilePage from "../../utils/mobile-page";

import formatCurrency from "../../../../services/currency";

import { UserIcon, CloseIconSlim, HelpIcon } from "../../mobile-templates/general";
import { BonusIcon } from "../../utils/icons";

export class SlidingContainer extends Component {
	componentWillMount() {
		MobilePage.addOnRightMenuChange(this.listener = (e => this.setState({})));
	}
	componentDidUnmount() {
		MobilePage.removeOnRightMenuChange(this.listener);
	}
	render({ children }) {
		return <div
			id="right-menu"
			class={"fixed z-10 -right-full top-0 bottom-0 w-full bg-black/70 pl-12 transition-all " + (MobilePage.isRightMenuOpen() ? "-translate-x-full" : "")}
			onClick={(e) => {
				if (e.target != e.currentTarget)
					return;
				MobilePage.closeRightMenu();
			}}
		>
			{children}
		</div>;
	}
}

export default class MenuRight extends Component {
	render() {
		return (
			<SlidingContainer>
				<div class="absolute top-0 left-0 w-12 p-1 pt-2 text-white" onClick={(e) => { MobilePage.closeRightMenu(); }}>
					<CloseIconSlim />
				</div>

				{User.isLogged() ? <LoggedUserMenu /> : <GuestUserMenu />}
			</SlidingContainer>
		);
	}
}

export class GuestUserMenu extends Component {
	render() {
		return (
			<div id="guest-user-buttons" class="h-full w-full max-w-sm border-l border-black bg-blue-whale-800 text-white">
				<div class="pt-2">
					<div class="p-2 px-2">
						<div class="pb-1 text-center">
							<Trans>Already have an account?</Trans>
						</div>
						<a class="mx-auto w-40 bg-kobaaccent-500 text-black py-2 text-center text-sm uppercase block rounded" href="#login">
							<Trans>Login</Trans>
						</a>
					</div>
					<div class="p-2 px-2">
						<div class="pb-1 text-center">
							<Trans>Don't have an account</Trans>
						</div>
						<a class="mx-auto w-40 bg-kobaaccent-500 text-black py-2 text-center text-sm uppercase block rounded" href="#register">
							<Trans>Register</Trans>
						</a>
					</div>
				</div>
				<div class="bg-blue-whale-800 py-2 hidden">
					<div class="flex items-center justify-center gap-1 p-2 px-2">
						<div class="w-8">
							<HelpIcon class="w-full" />
						</div>
						<div class="pb-1 text-center"><Trans>Need Help?</Trans></div>
					</div>
					<div class="mx-auto w-40 border border-brand-900 bg-blue-whale-600 py-2 text-center text-sm uppercase"><Trans>Live Chat</Trans></div>
				</div>
			</div>
		);
	}
}

export function WalletsPanel({ balance, payable, bonus, balanceText = null, payableText = null, bonusText = null }) {
	return <div class="text-sm w-full bg-slate-200 rounded border border-slate-400 p-1 px-2">
		<span class="text-blue-whale-600 text-sm font-bold"><Trans>Wallets</Trans></span>
		<div class="w-full">
			<WalletsRow><span>{balanceText || <Trans>Balance</Trans>}</span> <span class="font-mono">{balance}</span></WalletsRow>
			<WalletsRow><span>{payableText || <Trans>Payable</Trans>}</span> <span class="font-mono">{payable}</span></WalletsRow>
			<WalletsRow><span><BonusIcon class="h-3 inline-block relative -top-px" /> {bonusText || <Trans>Bonus</Trans>}</span> <span class="font-mono">{bonus}</span></WalletsRow>
		</div>
	</div>
}

export function WalletsRow({ children }) {
	return <div class="flex justify-between items-center border-b border-b-slate-400 border-dotted last:border-b-0">{children}</div>
}

export class LoggedUserMenu extends Component {
	closeMenu() {
		MobilePage.closeRightMenu();
	}
	render() {
		return (
			<div id="logged-user-buttons" class="flex h-full w-full max-w-sm ml-auto flex-col border-l border-black bg-blue-whale-800 text-white">
				<div class="flex flex-col gap-2 bg-kobaaccent-400 text-black p-2">
					<div class="flex grow">
						<div class="aspect-square h-11 p-1">
							<UserIcon />
						</div>
						<div class="flex flex-col justify-center w-full">
							<div class="text-xs">{User.username()}</div>
							<div class="text-lg text-blue-whale-600">
								<span>{formatCurrency(User.balance())} {Config.currencySymbol}</span>
							</div>
							<WalletsPanel 
								balance={formatCurrency(User.balance())} 
								payable={formatCurrency(User.payable())} 
								bonus={formatCurrency(User.bonus())}
							/>
						</div>
					</div>
					<div class="flex gap-2 w-full">
						<a class="rounded bg-blue-whale-600 text-white py-1 text-center text-sm uppercase w-full" href="/user/payment-gateway/deposit" onClick={() => this.closeMenu()}>
							<Trans>Deposit</Trans>
						</a>
						<a class="rounded bg-blue-whale-600 text-white py-1 text-center text-sm uppercase w-full" href="/user/payment-gateway/withdraw" onClick={() => this.closeMenu()}>
							<Trans>Withdraw</Trans>
						</a>
					</div>
				</div>
				<div class="min-h-0 grow overflow-y-auto">
					<div onClick={e => MobilePage.closeRightMenu()}>
						<a href="/user" class="flex h-10 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Account</Trans>
							</span>
						</a>
						<a href="/user/password" class="flex h-10 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Change Passowrd</Trans>
							</span>
						</a>
						<div class="border-b border-kobaaccent-500 w-full"></div>
						<a href="/user/payment-gateway/deposit" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Deposit</Trans>
							</span>
						</a>
						<a href="/user/payment-gateway/withdraw" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Withdraw</Trans>
							</span>
						</a>
						<a href="/user/vouchers" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Vouchers</Trans>
							</span>
						</a>
						<a href="/user/bonus-states" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>My Bonuses</Trans>
							</span>
						</a>
						<div class="border-b border-kobaaccent-500 w-full"></div>
						<a href="/user/tickets" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>All Bets History</Trans>
							</span>
						</a>
						<a href="/user/transactions" class="flex h-10 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Account History</Trans>
							</span>
						</a>
						<div class="border-b border-kobaaccent-500 w-full"></div>
						<a href="/contacts" class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white" onClick={() => this.closeMenu()}>
							<span class="px-2">
								<Trans>Help Page</Trans>
							</span>
						</a>
						{!!Session.fetch('club') && !Session.fetch('manager') && <a href="/manager/dashboard" onClick={() => this.closeMenu()} class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white">
							<span class="px-2">
								<Trans>Players</Trans>
							</span>
						</a>}
						<div class="flex h-12 items-center bg-blue-whale-800 px-2 uppercase text-white fn-logout-btn" onClick={e => { Session.logoutPromise().finally(e => Page.rerender()) }}>
							<span class="px-2">
								<Trans>Logout</Trans>
							</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
